import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { chunk } from 'lodash';
import { useCallback } from 'react';
import { fetchBulkAltTextSuggestions, fetchSingleAltTextSuggestions } from './alt-text-suggestions-api';
import { enqueueRequest } from './request-queue';
const DEFAULT_CHUNK_SIZE = 80;
export const useSuggestionsData = function (options) {
  if (options === void 0) {
    options = {};
  }
  const {
    chunkSize = DEFAULT_CHUNK_SIZE,
    failedToGenerateMessage = 'Failed to generate alt text'
  } = options;
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const getSingleSuggestionsData = useCallback(async (itemType, imageData) => {
    try {
      const data = await enqueueRequest(() => fetchSingleAltTextSuggestions(httpClient, errorHandler, {
        image: imageData,
        itemType
      }, {
        failedToGenerateMessage
      }));
      return {
        suggestions: data.suggestions ?? []
      };
    } catch (err) {
      console.error('single-alt-text error', err);
      return {
        errorMessage: errorHandler.getResolvedError(err).message,
        suggestions: []
      };
    }
  }, [httpClient, errorHandler, failedToGenerateMessage]);
  const getMultipleSuggestionsData = useCallback(async (itemType, images) => {
    const chunks = chunk(images, chunkSize);
    const promises = chunks.map(slice => enqueueRequest(() => fetchBulkAltTextSuggestions(httpClient, {
      images: slice,
      itemType
    })).catch(error => {
      console.error('bulk-alt-text error', error);
      return [];
    }));
    const results = await Promise.all(promises);
    return results.flat();
  }, [httpClient, chunkSize]);
  return {
    getMultipleSuggestionsData,
    getSingleSuggestionsData
  };
};
//# sourceMappingURL=use-suggestions-data.js.map